// Generated by ReScript, PLEASE EDIT WITH CARE

import * as TopNavigationBar$PrezzeeRibbon from "../../common/TopNavigationBar/TopNavigationBar.bs.js";
import * as TopNavigationBar__Theme__Business$PrezzeeRibbon from "./TopNavigationBar__Theme__Business.bs.js";

var include = TopNavigationBar$PrezzeeRibbon.Component(TopNavigationBar__Theme__Business$PrezzeeRibbon.Theme);

var Background = include.Background;

var StaticBackground = include.StaticBackground;

var FadeBackground = include.FadeBackground;

var Styles = include.Styles;

var make = include.make;

export {
  Background ,
  StaticBackground ,
  FadeBackground ,
  Styles ,
  make ,
}
/* include Not a pure module */
